<script setup lang="ts" generic="TValue">
import { chipGroupKey } from '~/composables/group';

const props = defineProps<{
  label?: string
  value?: TValue
}>();

const group = inject(chipGroupKey);
const isChecked = computed(() => group?.isSelected(props.value) ?? false);
function onUpdate() {
  group?.toggle(props.value);
}
</script>

<template>
  <label
    class="border border-neutral-30 rounded-lg flex items-center px-s py-2xs
      has-[:checked]:bg-secondary-70 has-[:checked]:underline
      focus-within:outline focus-within:outline-2 focus-within:outline-primary-40
      hover:underline decoration-1
      underline-offset-2
      active:bg-primary-40 active:text-white"
  >
    <input
      type="checkbox"
      class="peer sr-only"
      :value
      :checked="isChecked"
      autocomplete="off"
      @change="onUpdate"
    >
    <span v-text="label" />
  </label>
</template>

<style lang="css" scoped>
label:focus-within:not(:has(:focus-visible)) {
  @apply outline-none;
}
</style>
